import { AdminTokensEndpoints, fetcher } from ".."

const useTokens = () => {
  const getToken = async (tokenId: string) => {
    const response = await fetcher(AdminTokensEndpoints.find(tokenId))

    return response.token
  }

  return {
    getToken
  }
}

export default useTokens
